import jQuery from 'jquery';
import slick from 'slick-carousel';

/**
 * For `banners` module.
 *
 */
export default function() {
  (function($) {
    var options = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      prevArrow:
        '<button class="slick-arrow slick-prev"><i class="fa fa-chevron-left"></i>Previous Slide</button>',
      nextArrow:
        '<button class="slick-arrow slick-next"><i class="fa fa-chevron-right"></i>Next Slide</button>',
      autoplay: true,
      autoplaySpeed: 5000
    };

    $('.mg-hero-carousel').each(function(i) {
      $(this).slick(options);
    });
  })(jQuery);
}



// WEBPACK FOOTER //
// ./assets/src/js/components/banners.js